export default __webpack_public_path__ + "static/media/554.5fa4cbf8.png";